import {
  NEXT_PUBLIC_API_URL,
  NEXT_PUBLIC_SLS,
  NEXT_PUBLIC_KRAVEN_HASURA,
} from "@/config/env";

export const dashboardApiCalls = {
  licenses: {
    activations: (companyId: string) => `${NEXT_PUBLIC_API_URL}/api/b2b-v2/activations/${companyId}/licenses/`,
    students: (companyId: string) => `${NEXT_PUBLIC_API_URL}/api/b2b-v2/activations/${companyId}/?page_size=20`,
    studentsByPage: (companyId: string, page: number) =>
      `${NEXT_PUBLIC_API_URL}/api/b2b-v2/activations/${companyId}/?page_size=20&page=${page}`,
    createStudents: (companyId: string) => `${NEXT_PUBLIC_API_URL}/api/b2b-v2/activations/${companyId}/`,
    renewStudents: (companyId: string) => `${NEXT_PUBLIC_API_URL}/api/b2b-v2/activations/${companyId}/renew-months/`,
    filteredStudents: (companyId: string, queryParams: string) =>
      `${NEXT_PUBLIC_API_URL}/api/b2b-v2/activations/${companyId}/?${queryParams}&page_size=20`,
    bulkMonthsAssign: (companyId: number) =>
      `${NEXT_PUBLIC_API_URL}/api/b2b-v2/activations/${companyId}/renew-months-bulk/`,
    coursesTakenByStudents: `${NEXT_PUBLIC_KRAVEN_HASURA}/v1/graphql`,
  },
  permission: {
    getAdmins: (companyId: string) => `${NEXT_PUBLIC_API_URL}/api/b2b-v2/activations/${companyId}/?role=admin`,
    isUserActive: (companyId: string, email: string) =>
      `${NEXT_PUBLIC_API_URL}/api/b2b-v2/activations/${companyId}/?search=${email}`,
    assignPermission: (companyId: string) =>
      `${NEXT_PUBLIC_API_URL}/api/b2b-v2/activations/${companyId}/administrators/`,
    searchUsers: (companyId: string, searchTerm: string) =>
      `${NEXT_PUBLIC_API_URL}/api/b2b-v2/activations/${companyId}/?search=${searchTerm}`,
  },
  extensions: {
    getExtensions: (companyId: string) => `${NEXT_PUBLIC_SLS}/license-extentions/list?company_id=${companyId}&status=0`,
    resolveExtensions: () => `${NEXT_PUBLIC_SLS}/license-extentions/resolve`,
  },
  stats: {
    months: (companyId: string, endDate: string) => `${NEXT_PUBLIC_API_URL}/api/b2b-v2/stats/${companyId}/flexible/`
  }
};
